<app-layout-public>
    <div id="okta-reset-password-container" class="splash-card-wrapper-thin"></div>
</app-layout-public>
